import { render, staticRenderFns } from "./CdrOverviewTab.vue?vue&type=template&id=815b66de&scoped=true"
import script from "./CdrOverviewTab.vue?vue&type=script&lang=js"
export * from "./CdrOverviewTab.vue?vue&type=script&lang=js"
import style0 from "./CdrOverviewTab.vue?vue&type=style&index=0&id=815b66de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815b66de",
  null
  
)

export default component.exports